import { Flex, Text } from '@mantine/core';
import {
  CELL_PADDING,
  FONT_SIZE,
  HEADER_BG,
  INDENT_SIZE,
  LINE_HEIGHT,
  TEXT_COLOR_SECONDARY
} from '../tableConstants';
import { useTableStyles } from '../tableConstants';
import { TbChevronDown, TbChevronUp } from 'react-icons/tb';
import { MultiFundHeaderRow } from './MultiFundHeaderRow';
import { idCreator } from '../../../../../Project/utils/idCreator';

export const QuestionHeader = ({
  id,
  number,
  name,
  fundKeys = [],
  funds,
  isMultiFunds = false,
  isOpen = true,
  onToggle
}) => {
  const { classes } = useTableStyles();

  if (isMultiFunds) {
    return (
      <MultiFundHeaderRow
        id={`formpf-question-header-multi-${idCreator(`${number}-${name}`)}`}
        number={number}
        name={name}
        fundKeys={fundKeys}
        funds={funds}
        isOpen={isOpen}
        onToggle={onToggle}
      />
    );
  }

  return (
    <Flex
      id={id || `formpf-question-header-${idCreator(`${number}-${name}`)}`}
      className={classes.borderBottom}
    >
      <Flex
        id={`formpf-question-header-left-${idCreator(`${number}-${name}`)}`}
        maw="50%"
        miw="50%"
      >
        <Text
          id={`formpf-question-header-number-${idCreator(`${number}-${name}`)}`}
          p={CELL_PADDING}
          className={classes.borderRight}
          bg={HEADER_BG}
          maw={INDENT_SIZE}
          miw={INDENT_SIZE}
          ta="center"
          fz={FONT_SIZE}
          lh={LINE_HEIGHT}
          fw={600}
          c={TEXT_COLOR_SECONDARY}
        >
          {number}
        </Text>

        <Flex
          id={`formpf-question-header-toggle-${idCreator(`${number}-${name}`)}`}
          onClick={onToggle}
          component="button"
          align="center"
          gap="8px"
          flex="auto"
          p={CELL_PADDING}
          bg={HEADER_BG}
        >
          <Text
            id={`formpf-question-header-name-${idCreator(`${number}-${name}`)}`}
            fw={600}
            c={TEXT_COLOR_SECONDARY}
            fz={FONT_SIZE}
            lh={LINE_HEIGHT}
          >
            {name}
          </Text>
          {isOpen ? (
            <TbChevronUp color={TEXT_COLOR_SECONDARY} size={16} />
          ) : (
            <TbChevronDown color={TEXT_COLOR_SECONDARY} size={16} />
          )}
        </Flex>
      </Flex>

      <Text
        id={`formpf-question-header-right-${idCreator(`${number}-${name}`)}`}
        p={CELL_PADDING}
        bg={HEADER_BG}
        miw="50%"
        maw="50%"
      ></Text>
    </Flex>
  );
};
